// Shared state for the 3-step "add partner" wizard. It starts empty — adding a
// partner should feel like doing it, not replaying a scripted one. The inputs
// carry example placeholders (e.g. "Sala Apolo"); the governance user fills in a
// real organisation, WebID and themes.

export const draft = $state({
  name: '',
  email: '',
  webId: '',
  // exact URLs communicated by the partner; knowing them does not imply access
  inboundContainers: [],
  // which themed cubes to share with this partner — chosen on the access step
  themes: {},
  // set by the publish step
  result: null,
});
